import { fcaFastApi, fcaGateWay, fcaReportGateway } from "../../services/authorizationService";
import * as serviceEndpoints from "../../config/serviceEndPoints";
import { isEnabled } from "../../services/featureFlags";

const CHARTS_FLAG = "migrate_dashboard_charts";

export const getDashboard = (params, isAssetDashboard = false) =>
    isAssetDashboard
        ? fcaFastApi.get(serviceEndpoints.dashboardEndPoints.getAssetDashboard, { params })
        : isEnabled(CHARTS_FLAG)
          ? fcaFastApi.get(serviceEndpoints.dashboardEndPoints.getDashboard, { params })
          : fcaReportGateway.post(serviceEndpoints.dashboardEndPoints.getReportDashboard, params);

export const getChartsDashboardPython = params => {
    if (isEnabled(CHARTS_FLAG)) {
        const path =
            params?.chart_type === "horizontal_chart"
                ? serviceEndpoints.dashboardEndPoints.getHorizontalChart
                : serviceEndpoints.dashboardEndPoints.getChartsDashboard;
        return fcaFastApi.get(path, { params });
    }
    return fcaReportGateway.post(serviceEndpoints.dashboardEndPoints.getChartsDashboardPython, params);
};

export const getFciChart = params =>
    isEnabled(CHARTS_FLAG)
        ? fcaFastApi.get(serviceEndpoints.dashboardEndPoints.getFciChart, { params })
        : fcaReportGateway.post(serviceEndpoints.dashboardEndPoints.getReportFciChart, params);

export const getMap = params =>
    isEnabled(CHARTS_FLAG)
        ? fcaFastApi.get(serviceEndpoints.dashboardEndPoints.getMap, { params })
        : fcaReportGateway.post(serviceEndpoints.dashboardEndPoints.getReportMap, params);

export const getMasterFilter = (params, key) => fcaGateWay.get(`${serviceEndpoints.dashboardEndPoints.masterFilter}/${key}`, { params });
export const getRecommendationMasterFilter = params =>
    fcaGateWay.get(`${serviceEndpoints.dashboardEndPoints.getRecommendationMasterFilter}/get_list`, {
        params
    });
export const getAllLegents = params =>
    (isEnabled("migrate_dashboard_reads") ? fcaFastApi : fcaGateWay).get(serviceEndpoints.dashboardEndPoints.getAllLegents, { params });

export const getFcaChartExcelExport = params =>
    fcaGateWay.get(serviceEndpoints.dashboardEndPoints.getFcaChartExcelExport, { method: "GET", responseType: "blob", params });

export const getFciChartExcelExport = params =>
    fcaGateWay.get(serviceEndpoints.dashboardEndPoints.getFciChartExcelExport, { method: "GET", responseType: "blob", params });

export const getHorizontalChartExport = params =>
    fcaGateWay.get(serviceEndpoints.dashboardEndPoints.getHorizontalChartExport, { method: "GET", responseType: "blob", params });

export const getLandingPageData = params => fcaGateWay.get(serviceEndpoints.dashboardEndPoints.landingPageData, { params });

export const getLandingPageReports = params =>
    fcaGateWay.get(`${serviceEndpoints.dashboardEndPoints.landingPageData}/capital_planning_report`, { params });

export const getWidgetData = params =>
    (isEnabled("migrate_dashboard_reads") ? fcaFastApi : fcaGateWay).get(serviceEndpoints.dashboardEndPoints.widgetData, { params });

export const SaveFilterQuery = params => fcaReportGateway.post(serviceEndpoints.dashboardEndPoints.saveFilterQuery, params);
export const getQuery = params => fcaReportGateway.get(serviceEndpoints.dashboardEndPoints.saveFilterQuery, { params });
export const deleteQuery = id => fcaReportGateway.delete(`${serviceEndpoints.dashboardEndPoints.saveFilterQuery}${id}/`);
export const updateFilterQuery = (params, id) => fcaReportGateway.patch(`${serviceEndpoints.dashboardEndPoints.saveFilterQuery}${id}/`, params);
export const addQueriesToFavorites = params => fcaReportGateway.post(`${serviceEndpoints.dashboardEndPoints.addQueriesToFavorites}/`, params);
export const assignFavoriteQueryToUsers = params =>
    fcaReportGateway.post(`${serviceEndpoints.dashboardEndPoints.assignFavoriteQueryToUsers}/`, params);
export const getUsersByClientQuery = params => fcaReportGateway.get(`${serviceEndpoints.dashboardEndPoints.getUsersByClientQuery}`, { params });
export const getQueryFilterCreatedUsers = params =>
    fcaReportGateway.get(`${serviceEndpoints.dashboardEndPoints.getQueryFilterCreatedUsers}`, { params });
export const getQuickLinks = params => fcaReportGateway.get(`${serviceEndpoints.dashboardEndPoints.quickLinks}`, { params });
export const addToQuickLinks = data => fcaReportGateway.post(`${serviceEndpoints.dashboardEndPoints.quickLinks}`, data);
export const deleteQuickLinks = id => fcaReportGateway.delete(`${serviceEndpoints.dashboardEndPoints.quickLinks}${id}/`);
export const updateQuickLink = (id, params) => fcaReportGateway.patch(`${serviceEndpoints.dashboardEndPoints.quickLinks}${id}/`, params);
export const getDashboardLeaseAssetsCount = params => fcaGateWay.get(serviceEndpoints.dashboardEndPoints.getDashboardLeaseAssetsCount, { params });
export const getChartDynamicFields = params => fcaReportGateway.get(`${serviceEndpoints.dashboardEndPoints.getChartDynamicFields}`, { params });
